export default __webpack_public_path__ + "static/hero_right-8f76d8b42c9997f1fd95deb2eff96edc.png";